module.exports = __webpack_public_path__ + "static/media/linkedInIcon.6cad966d.svg";